import { Component, Input } from '@angular/core';
import { CardComponent } from "../../@theme/components/card/card.component";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RichiestaSequenziamentoDNA } from '../model/richiesta-sequenziamento-dna.better.entity';
import { CommonModule } from '@angular/common';
import { DataFormTableComponent } from "../component/data-form-table/data-form-table.component";
import { RisultatiSequenziamento } from '../model/risultati-sequenziamento.better.entity';
import { Router } from '@angular/router';
import { BetterService } from '../services/better.service';

@Component({
  selector: 'app-form-button',
  standalone: true,
  imports: [CardComponent, FontAwesomeModule, CommonModule, DataFormTableComponent],
  templateUrl: './form-button.component.html',
  styleUrl: './form-button.component.scss'
})
export class FormButtonComponent {
  @Input() colore:string='blue';
  @Input() form: any;
  richiesteSequenziamento: RichiestaSequenziamentoDNA[] | undefined;
  risultatiSequenziamento: RisultatiSequenziamento[]| undefined;

  constructor(
    private betterService: BetterService,
    private router: Router
  ) {}
  async ngOnInit() {
   
  }

 

  goTo() {
    this.router.navigate([this.form.url]);
  }

}
